import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { API } from "@/lib/api";

async function report(err, info, route) {
  try {
    await fetch(`${API}/telemetry/error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: String(err?.message || err).slice(0, 2000),
        stack: (err?.stack || info?.componentStack || "").slice(0, 8000),
        route,
        component: info?.componentStack?.split("\n")[1]?.trim(),
      }),
    });
  } catch {
    /* swallow — nothing to do */
  }
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    report(error, info, typeof window !== "undefined" ? window.location.pathname : null);
  }

  reset = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        className="min-h-screen flex items-center justify-center p-6 bg-hm-bg"
        data-testid="error-boundary"
      >
        <div className="hm-surface p-8 max-w-lg text-hm-fg">
          <div className="flex items-start gap-3">
            <AlertTriangle className="h-6 w-6 text-hm-danger shrink-0 mt-0.5" />
            <div>
              <div className="text-lg text-hm-fg font-medium">Something went sideways</div>
              <p className="text-sm text-hm-fg-muted mt-2 leading-relaxed">
                An unhandled error was caught by the shell. The event was posted to the
                telemetry log; you can safely reload.
              </p>
              <pre className="mt-4 p-3 rounded-md bg-hm-bg-1 border border-hm-border mono text-[11px] text-hm-fg-muted overflow-auto max-h-40">
                {String(this.state.error?.message || this.state.error)}
              </pre>
              <button
                onClick={this.reset}
                data-testid="error-boundary-reload"
                className="mt-5 inline-flex items-center gap-2 h-9 px-4 rounded-md bg-hm-accent text-hm-bg text-sm font-medium hover:bg-hm-accent-dim"
              >
                <RefreshCw className="h-4 w-4" />
                Reload
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
